import { c as _c } from "react/compiler-runtime";
import Loader from '@/components/Loader';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
type ProcessingOverlayProps = {
  className?: string;
  animate?: boolean;
};
export default function ProcessingOverlay(t0) {
  const $ = _c(19);
  const {
    className: t1,
    animate: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const animate = t2 === undefined ? false : t2;
  const t = useTranslations();
  const t3 = animate ? "animate-pulse" : "";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("grid size-full place-items-center rounded-lg", t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Loader variant="process" size="sm" />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t) {
    t7 = t("profile-page.upload-processing");
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <p className="body-2">{t7}</p>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t) {
    t9 = t("profile-page.upload-processing-hint");
    $[9] = t;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <p className="caption">{t9}</p>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <div className="flex flex-col items-center gap-2">{t6}{t8}{t10}</div>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t4) {
    t12 = <div className={t4} style={t5}>{t11}</div>;
    $[16] = t11;
    $[17] = t4;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}